export default "__VITE_ASSET__xVKylLE8__";